
// Tut Custom fields ids. Mojet delaem settings kakoy ni bud?

// For test in Goodday Sandbox
// export const DealSize_CustomFieldId = 'YSpf0Q'
// export const ProductType_CustomFieldId = 'j13V7H'

export const AppZenCompanyId = 'EQaGU1'
export const DealSize_CustomFieldId = 'RYq7dX'
export const ProductType_CustomFieldId = 'y3UDn8'
